import { Box } from "@material-ui/core";
import React from "react";
import { ClipLoader } from "react-spinners";

function LoadingScreen() {
  return (
    <div style={{ backgroundColor: "white", height: '100vh', width: "100%" }}>
      <Box textAlign='center' mt={8}>
        <ClipLoader
          size={25}
          color={"black"}
          loading={true}
        />
      </Box>
    </div>)
}

export default LoadingScreen;
